import { InfoCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Input, Tooltip } from 'antd';
import type React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useKeyAction } from '../../../hooks/useKeyAction.ts';

export const SearchField: React.FC<{
  value: string;
  onChange: (value: string) => void;
}> = ({ value, onChange }) => {
  const [internalValue, setInternalValue] = useState(value);
  const [debouncedSearch] = useDebounce(internalValue, 500);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (value !== debouncedSearch) {
      onChange(debouncedSearch);
    }
  }, [value, debouncedSearch, onChange]);

  const action = useMemo(() => {
    if (focused) {
      return () => {
        setInternalValue('');
      };
    } else {
      return null;
    }
  }, [focused]);

  useKeyAction('Escape', action);

  return (
    <Input
      allowClear
      autoFocus
      size="large"
      placeholder="Name, SVNR, Auftragsnummer ..."
      value={internalValue || ''}
      onChange={e => setInternalValue(e.target.value)}
      prefix={<SearchOutlined />}
      suffix={
        <Tooltip title="Suche Befunde nach Name, SVNR, Auftragsnummer">
          <InfoCircleOutlined />
        </Tooltip>
      }
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
    />
  );
};
